import { Helmet } from 'react-helmet-async';
import { companyInfo } from '../data/siteData';

export default function SEO({
  title,
  description,
  ogImage,
  canonical,
  children
}) {
  const defaultTitle = "Hovendals | Hegn og porte | 100% kvalitetshåndværk i hele landet";
  const defaultDesc = "Hovendals er din partner inden for hegn, porte, carporte, skure og låger. 100% kvalitetshåndværk til private og erhverv i hele Danmark.";
  const finalTitle = title || defaultTitle;
  const finalDesc = description || defaultDesc;
  const finalImage = ogImage || companyInfo.logoLarge;

  return (
    <Helmet>
      <html lang="da" />
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:type" content="website" />
      {finalImage && <meta property="og:image" content={finalImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      {finalImage && <meta name="twitter:image" content={finalImage} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {children}
    </Helmet>
  );
}
